import type { ThunkReturnType } from "types";
import { createAsyncThunk } from "infrastructure/store/lib";
import type { RootState, AsyncThunk } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import { ApiRouteTypes } from "consts/enpoints/api";
import { MenuItem } from "consts/shipmentTracking";
import { concat } from "util/support";
import { payloadCreator } from "util/api";
import type { TransactionTrackingDeliveryCodesResponse } from "./types";
import { sliceToken } from "./state";
import { getTransactionTrackingDeliveryCodes } from "./api";

export const getTransactionTrackingDeliveryCodesThunk: AsyncThunk<
    ThunkReturnType<TransactionTrackingDeliveryCodesResponse>,
    string | undefined,
    {}
> = createAsyncThunk(
    concat([sliceToken, ApiRouteTypes.GetTransactionTrackingDeliveryCodes]),
    payloadCreator(getTransactionTrackingDeliveryCodes),
    {
        condition: (_, { getState }) => {
            const { shipmentTracking } = getState() as RootState;

            return ![ApiState.Pending].includes(
                shipmentTracking[MenuItem.TransactionTrackingDeliveryCodes].tableLoadingState
            );
        }
    }
);
